import { get, post, prefix } from './base'

// 获取手机验证码
export function requestSMSCode(params) {
    return post(prefix + 'passport/v1/login/requestSMSCode', params)
}

// 验证码登录
export function verifySMSCode(params) {
    return post(prefix + 'passport/v1/login/SMSCode', params)
}

// 密码登录
export function verifyPassword(params) {
    return post(prefix + 'passport/v1/login/password', params)
}

// 退出
export function logout(params) {
    return get(prefix + 'passport/v1/logout', params)
}
